import { isEmpty, isString } from "lodash"

import i18n from "@/i18n"
import { ValidateRule, ValidateRuleKey, ValidatorArgs } from "@/types/rule"
import validator from "@/utils/rules/rule"

const errorMessages = (translate: string, ctx: Record<string, string>) =>
  i18n.t(translate, { ...ctx })

const makeValidateArgs = (args: ValidatorArgs, rule: string): Record<string, ValidatorArgs> => {
  if (isString(args) && (args as string).split("|").length > 1) {
    return (args as string).split("|").reduce((acc: Record<string, string>, cur: string) => {
      const [key, value] = cur.split(":")
      acc[key] = String(value).trim()

      return acc
    }, {})
  } else {
    return {
      [`${rule}`]: args,
    }
  }
}

export default function validate(
  name: string,
  rules: ValidateRule,
  customMessage?: ValidateRuleKey,
) {
  const returnRules = []
  for (const [rule, args] of Object.entries(rules)) {
    if (!isEmpty(args)) {
      const validateArgs = makeValidateArgs(args, rule)
      const validFunc = (v: ValidatorArgs) =>
        validator[rule](v, validateArgs) ||
        (customMessage && customMessage[rule as keyof ValidateRule]) ||
        errorMessages(`rules.${rule}`, { name, ...validateArgs })

      returnRules.push(validFunc)
    }
  }

  return returnRules
}

export const checkZoneCellIsFloat = (value: string) => {
  return /^-?(\d*\.?\d*|\.\d*|-\.?)$/.test(value)
}
